<template>
  <div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'AboutUsContainer'
};
</script>
<style scoped lang="less">
.about-us {
  font-family: 微软雅黑;
  width: 100%;
  .header {
    width: 100%;
    height: 240px;
    line-height: 240px;
    text-align: center;
    background: url('~@/assets/recycling/index/about-us-bg.png') center/cover no-repeat;
    // background-size: cover;
    color: #ffffff;
    font-size: 36px;
    font-weight: 400;
    letter-spacing: 12px;
  }
  .main {
    width: 1080px;
    margin: 50px auto 84px;
    text-align: center;
    .main-title {
      color: rgb(34, 34, 34);
      font-size: 30px;
      font-weight: 700;
      letter-spacing: 4px;
      position: relative; /* 为伪元素定位做准备 */
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0; /* 调整上下间距 */
      &::before,
      &::after {
        content: '';
        width: 100px; /* 让线条自动延伸 */
        height: 1px; /* 线的高度 */
        background: rgb(221, 221, 221); /* 线的颜色 */
        margin: 0 15px; /* 线与文字之间的间距 */
      }
    }
    .main-content {
      margin-top: 44px;
      color: rgb(77, 81, 90);
      font-size: 20px;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0px;
      text-align: left;
      text-indent: 2em;
    }
    .main-bg {
      margin-top: 37px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 537px;
        height: 321px;
      }
    }
  }
}
.bottomUrl {
  margin-top: 60px;
}
</style>